<template>
  <v-layout row>
    <v-flex xs12>
      <v-list class="devices-list">
        <template v-for="item in devices">
          <v-list-tile
            :key="item.title"
            avatar
            @click="openDevice(item)"
            append
          >
            <v-list-tile-avatar>
              <v-icon :color="$ponceConfig.checkStatus(item.Event ? item.Event.State.value : STATES.OFF)">trip_origin</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content >
              <strong><v-list-tile-title v-html="getName(item)"></v-list-tile-title></strong>
              <v-list-tile-sub-title v-if="item.Crops.length" class="device-lot-name">{{item.Crops[0].name}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-else class="device-lot-name">Sin Lote</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>arrow_forward_ios</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { STATES } from '../../constants/constants';

export default {
  name: 'DevicesList',
  props: {
    devices: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      clickedDevice: {},
      STATES
    };
  },
  computed: {
  },
  created () {
  },
  methods: {
    openDevice (item) {
      mixpanel.track('Open device in list', {'id': item.id});
      gtag('event', 'open_device_in_list', {event_category: 'click', event_label: 'Open device in list', value: item.id});
      this.$router.push({ name: 'DeviceDetail', params: { id: `${item.id}` } });
    },
    getName (item) {
      if (item.orgName) {
        return `${item.orgName} - ${item.name}`;
      } else {
        return item.name;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// DevicesList.vue?d4abd0ac